// extracted by css-extract-rspack-plugin
export default {"heading":"xYbpk2NQEdIqOHID","list":"yZJVqOTNYpYSXDN1"};